import type { z } from "zod/v4";
import { Config } from "./Config";
import { loadVersion } from "./loadVersion";

export function createConfig<
  TSchema extends z.ZodObject<z.ZodRawShape>,
>(options: { schema: TSchema; configPath: string; versionPath: string }) {
  const config = new Config(options);

  return {
    initConfig: config.initConfig.bind(config),
    getConfig: config.getConfig.bind(config),
    useConfig: config.useConfig.bind(config),
    loadVersion: () => loadVersion(options.versionPath),
    ConfigProvider: config.ConfigProvider,
    TestConfigProvider: config.TestConfigProvider,
  };
}
